import React from 'react';
import { MdCategory, MdFactory } from 'react-icons/md';
import { LuMegaphone, LuMapPin, LuLandmark } from 'react-icons/lu';
import { MdStorefront } from 'react-icons/md';
import { PersonRenderer } from 'components/common/ag-grid';
import EmailRenderer from 'components/common/ag-grid/EmailRenderer';
import PhoneRenderer from 'components/common/ag-grid/PhoneRenderer';
import { iconCell } from 'components/common/ag-grid';
import CustomerSecondaryBadge from './CustomerSecondaryBadge';
import CustomerWebsiteLink from './CustomerWebsiteLink';
import CustomerLink from './CustomerLink';

const CustomerNameCell = (props) => <CustomerLink {...props} withAvatar />;

export const columnDefs = [
  {
    headerName: 'ID#',
    field: 'customer_code',
    minWidth: 110,
    cellRenderer: CustomerLink
  },
  {
    headerName: 'Customer name',
    field: 'name',
    minWidth: 300,
    pinned: 'left',
    cellRenderer: CustomerNameCell
  },
  {
    headerName: 'Type of customer',
    field: 'type_of_company',
    minWidth: 150,
    cellRenderer: iconCell(MdCategory)
  },
  {
    headerName: 'Industry',
    field: 'industry',
    minWidth: 250,
    cellRenderer: iconCell(MdFactory)
  },
  {
    headerName: 'Source',
    field: 'source',
    minWidth: 150,
    cellRenderer: iconCell(LuMegaphone)
  },
  { 
    headerName: 'Telephone',
    field: 'telephone',
    minWidth: 200,
    cellRenderer: PhoneRenderer
  },
  { 
    headerName: 'Email',
    field: 'email',
    minWidth: 200,
    cellRenderer: EmailRenderer
  },
  { 
    headerName: 'Fax',
    field: 'fax',
    minWidth: 200,
    cellRenderer: PhoneRenderer
  },
  { 
    headerName: 'Tax code',
    field: 'tax_code',
    minWidth: 200
  },
  { 
    headerName: 'Website',
    field: 'website',
    minWidth: 200,
    cellRenderer: CustomerWebsiteLink
  },
  { 
    headerName: 'Number of employees',
    field: 'employess',
    minWidth: 250
  },
  { 
    headerName: 'Legal status',
    field: 'legal_status',
    cellRenderer: iconCell(LuLandmark),
    minWidth: 150
  },
  { 
    headerName: 'Country',
    field: 'country_name',
    cellRenderer: iconCell(LuMapPin),
    minWidth: 150
  },
  { 
    headerName: 'Main Contact',
    field: 'main_contact',
    cellRenderer: PersonRenderer,
    minWidth: 150
  },
  { 
    headerName: 'Secondary contact',
    field: 'secondary_contact',
    minWidth: 250,
    cellRenderer: CustomerSecondaryBadge
  },
  { 
    headerName: 'KYC',
    field: 'kyc_type',
    minWidth: 150
  },
  // { 
  //   headerName: 'Classify customer',
  //   field: 'classify_customer.name',
  //   minWidth: 150,
  //   cellRenderer: CustomerLink
  // },
  { 
    headerName: 'Sales unit',
    field: 'sales_unit.description',
    cellRenderer: iconCell(MdStorefront),
    minWidth: 200
  },
  { 
    headerName: 'Updated date',
    field: 'updated_at',
    minWidth: 200
  },
  { 
    headerName: 'Created by',
    field: 'created_by',
    cellRenderer: PersonRenderer,
    minWidth: 120
  },
  { 
    headerName: 'Created date',
    field: 'created_at',
    minWidth: 200
  }
];